export default __webpack_public_path__ + "static/media/train11.d28fe297.png";